import React from 'react'
const RootConfig = {
    routes:[{
        exact:true,
        path:'/',
        component:React.lazy(() => <div>aaa</div>),
        // exact:true
    }]
}

export default RootConfig
